export default __webpack_public_path__ + "static/d-feature-2-7fa6ed9b248c34fb53c3b3cb810565e0.png";